import { render, staticRenderFns } from "./NamelistHostStudents.vue?vue&type=template&id=251d80b1&"
import script from "./NamelistHostStudents.vue?vue&type=script&lang=js&"
export * from "./NamelistHostStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports